export default __webpack_public_path__ + "static/media/404-sorry-kid.6f1126dc.png";